var seminars_courses =
webpackJsonp_name_([41,50],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(706);

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// js/seminars_courses.32ff221168c039b1660e.js